import React from 'react';

const ProgressPlant = ({ percentage, current, target }) => {
  const getPlantEmoji = (percent) => {
    if (percent >= 80) return { emoji: '🌳', size: 88 };
    if (percent >= 60) return { emoji: '🌳', size: 72 };
    if (percent >= 40) return { emoji: '🪴', size: 64 };
    if (percent >= 20) return { emoji: '🌿', size: 48 };
    return { emoji: '🌱', size: 32 };
  };

  const plant = getPlantEmoji(percentage);

  return (
    <div className="progress-plant" data-testid="progress-plant">
      <div className="plant-container">
        <div className="plant-percentage">{Math.round(percentage)}%</div>
        <span className="plant-emoji" style={{ fontSize: `${plant.size}px` }}>
          {plant.emoji}
        </span>
      </div>
      <div className="plant-ground" />
      <div className="plant-progress-text">
        {current?.toLocaleString()} / {target?.toLocaleString()}
      </div>
    </div>
  );
};

export default ProgressPlant;
